import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import {
  TabloSidebarPanel,
  TabloSidebarPanelContext,
  TabloSidebarPanelEntry,
  TabloSidebarState,
} from './tablo-sidebar.types';

const MAIN_PANEL: TabloSidebarPanelEntry = {
  panel: 'main',
};

@Injectable()
export class TabloSidebarNavigationService {
  private readonly stackSubject = new BehaviorSubject<TabloSidebarPanelEntry[]>(
    [MAIN_PANEL],
  );

  readonly state$ = this.stackSubject.asObservable().pipe(
    map((stack) => this.createState(stack)),
    shareReplay(1),
  );

  get snapshot(): TabloSidebarState {
    return this.createState(this.stackSubject.value);
  }

  openRoot(panel: TabloSidebarPanel, context?: TabloSidebarPanelContext): void {
    if (panel === 'main') {
      this.stackSubject.next([MAIN_PANEL]);
      return;
    }

    this.stackSubject.next([
      MAIN_PANEL,
      {
        panel,
        context,
      },
    ]);
  }

  push(panel: TabloSidebarPanel, context?: TabloSidebarPanelContext): void {
    this.stackSubject.next([
      ...this.stackSubject.value,
      {
        panel,
        context,
      },
    ]);
  }

  back(): void {
    if (this.stackSubject.value.length <= 1) {
      return;
    }

    this.stackSubject.next(this.stackSubject.value.slice(0, -1));
  }

  resetToMain(): void {
    this.stackSubject.next([MAIN_PANEL]);
  }

  private createState(stack: TabloSidebarPanelEntry[]): TabloSidebarState {
    return {
      stack,
      current: stack[stack.length - 1],
      canGoBack: stack.length > 1,
    };
  }
}
